import { makeStyles } from 'tss-react/mui';

export const useSupportPageStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
  },
  grid: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
    '& > div:first-of-type': {
      marginRight: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        marginRight: 0,
        marginBottom: theme.spacing(3),
      }
    },
    marginBottom: theme.spacing(15),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(12),
    }
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '21px',
    width: '100%',
    '&:last-of-type': {
      minWidth: '328px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '328px',
      }
    },
    '&:first-of-type': {
      minWidth: '343px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '592px'
      }
    },
  },
  cardTitle: {
    fontWeight: 700,
  },
  cardLeft: {
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: '24px',
    },
  },
  cardRight: {
    minWidth: '343px',
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: '32px 24px',
    },
  },
  supportNumber: {
    fontSize: '24px'
  },
  h3Heading: {
    display: 'block',
    marginBottom: theme.spacing(3),
    color: theme.palette.secondary.main,
    fontSize: '34px'
  },
  footer: {
    '& a': {
      color: theme.palette.text.secondary
    }
  }
}));
